import { permissionObj } from "../../../Helpers/permission"
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
/**
 * TABS_PROVIDER
 * Defines the tabs available for the supplier module,
 * including their index and translation key (TRANS).
 */

export const TABS_PROVIDER = {

    PURCHASE_ORDERS: {
        INDEX: 0,
        TRANS: "purchase_orders",
    },
    SUPPLIERS: {
        INDEX: 1,
        TRANS: "suppliers",
    },
    MANAGE: {
        INDEX: 2,
        TRANS: "manage",
    },
    DOCUMENTATION: {
        INDEX: 3,
        TRANS: "documentation",
    }
}

export const STEPS_PROVIDER_CREATE = {
    COMPANY_DETAILS:0,  
    MANAGER_DETAILS:1,
    OTHER_DETAILS:2,
    ADD_PHOTO:3,
    SUMMARY: 4
}

export const STEPS_PROVIDER_UPDATE = {
    COMPANY_DETAILS:0,
    MANAGER_DETAILS:1, 
    OTHER_DETAILS:2,
    ADD_PHOTO:3
}

/**
 * PROVIDER_SUB_VIEW_MODEL
 * Represents subviews within the DOCUMENTATION tab.
 */
export const PROVIDER_SUB_VIEW_MODEL = {
    DOCUMENTATION: {
        APPROVAL_FLOW:"APPROVAL_FLOW",
        REQUESTS:"REQUESTS"
    }
}

/**
 * TAB_PERMISSION_SUPPLIER
 * Returns an object with permissions for each action (CREATE, UPDATE, DELETE, etc.)
 * mapped to specific tabs, based on the current subView.
 */
export function TAB_PERMISSION_SUPPLIER (subView){
    return {
        CREATE: {
            [TABS_PROVIDER.PURCHASE_ORDERS.INDEX]: permissionObj?.WEB_SUPPLIER_ORDER_CREATE,
            [TABS_PROVIDER.SUPPLIERS.INDEX]: permissionObj?.WEB_SUPPLIER_CREATE,
            [TABS_PROVIDER.DOCUMENTATION.INDEX]:
                subView === PROVIDER_SUB_VIEW_MODEL.DOCUMENTATION.APPROVAL_FLOW
                    ? permissionObj?.WEB_SUPPLIER_APPROVAL_FLOW_CREATE
                    : null,
        },
        UPDATE: {
            [TABS_PROVIDER.MANAGE.INDEX]: permissionObj?.WEB_SUPPLIER_CREATE, // update permission
        },
        DELETE: {
            [TABS_PROVIDER.PURCHASE_ORDERS.INDEX]: permissionObj?.WEB_SUPPLIER_ORDER_DELETE,
            [TABS_PROVIDER.SUPPLIERS.INDEX]: permissionObj?.WEB_SUPPLIER_DELETE,
            [TABS_PROVIDER.DOCUMENTATION.INDEX]:
                subView === PROVIDER_SUB_VIEW_MODEL.DOCUMENTATION.APPROVAL_FLOW
                    ? permissionObj?.WEB_SUPPLIER_APPROVAL_FLOW_DELETE
                    : null,
        },
        EXPORT: {
            [TABS_PROVIDER.PURCHASE_ORDERS.INDEX]: permissionObj?.WEB_SUPPLIER_ORDER_EXPORT,
            [TABS_PROVIDER.SUPPLIERS.INDEX]: permissionObj?.WEB_SUPPLIER_EXPORT,
        },
        IMPORT: {
            [TABS_PROVIDER.PURCHASE_ORDERS.INDEX]: permissionObj?.WEB_SUPPLIER_IMPORT,
            [TABS_PROVIDER.SUPPLIERS.INDEX]: permissionObj?.WEB_SUPPLIER_IMPORT,
        },
        ADVANCE_SEARCH: {
            [TABS_PROVIDER.SUPPLIERS.INDEX]:true,
        },
        RESTRICTIONS: {
             [TABS_PROVIDER.PURCHASE_ORDERS.INDEX]: permissionObj?.WEB_SUPPLIER_RESTRICTION_UPDATE,
            [TABS_PROVIDER.SUPPLIERS.INDEX]: permissionObj?.WEB_SUPPLIER_RESTRICTION_UPDATE,

        }
    }
}
